import React from 'react';
import { normalizeStatus, STATUS_LABELS } from '../utils/roles';

const STYLES: Record<string, string> = {
  open: 'bg-amber-50 text-amber-900 border-amber-200',
  pending: 'bg-amber-50 text-amber-900 border-amber-200',
  accepted: 'bg-sky-50 text-sky-900 border-sky-200',
  recording: 'bg-blue-50 text-blue-900 border-blue-200',
  in_progress: 'bg-blue-50 text-blue-900 border-blue-200',
  processing: 'bg-violet-50 text-violet-900 border-violet-200',
  completed: 'bg-emerald-50 text-emerald-900 border-emerald-200',
  sent: 'bg-green-100 text-green-900 border-green-300',
  cancelled: 'bg-gray-100 text-gray-700 border-gray-300',
  failed: 'bg-red-50 text-red-900 border-red-200',
};

const TicketStatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const key = normalizeStatus(status);
  return (
    <span className={`inline-flex px-2 py-0.5 text-xs font-semibold rounded border ${STYLES[key] ?? STYLES.open}`}>
      {STATUS_LABELS[key] ?? key}
    </span>
  );
};

export default TicketStatusBadge;
